import React from 'react';
import { useBulkOpsSessionContext } from '@atlassian/jira-bulk-operations-analytics/src/controllers/index.tsx';
import { ContextMenuAnalytics } from '../controllers/analytics/main/main.tsx';
import type { WithAnalyticsProps } from '../controllers/analytics/main/types.tsx';
import { ContextMenuContainer } from '../controllers/context-menu/index.tsx';
import { MeatballMenu as MeatballMenuInternal } from './meatball-menu/index.tsx';
import type { MeatballMenuProps } from './meatball-menu/types.tsx';
import { makeScope } from './utils.tsx';

export const MeatballMenu = ({
	cardId,
	selectedCardIds,
	analyticsMapping,
	scope,
	...props
}: WithAnalyticsProps<MeatballMenuProps>) => {
	const fullScope = makeScope(scope, 'meatball');
	const bulkOpsFlow = useBulkOpsSessionContext();

	return (
		<ContextMenuContainer
			isGlobal
			selectedCardIds={selectedCardIds}
			analyticsMapping={analyticsMapping}
			cardId={cardId}
			bulkOpsFlow={bulkOpsFlow}
		>
			<ContextMenuAnalytics scope={fullScope} cardId={cardId}>
				<MeatballMenuInternal scope={fullScope} {...props} />
			</ContextMenuAnalytics>
		</ContextMenuContainer>
	);
};
